import React, {useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import {MapContainer, Marker, Popup, TileLayer,  GeoJSON} from "react-leaflet";
import 'leaflet/dist/leaflet.css'
import SectionTitle from "./SectionTitle";
import '../assets/css/sigmap.css';
import MultiLingualContent from '../config/multilingualContent';
import {LanguageContext} from "../config/multilingualContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faMap,
} from '@fortawesome/free-solid-svg-icons';

const SigMap = () => {
      const { language, toggleLanguage } = useContext(LanguageContext);

      const [nigerGeoJson, setNigerGeoJson] = useState(null);

    // Charger le GeoJSON du Niger
    useEffect(() => {
        fetch('https://raw.githubusercontent.com/johan/world.geo.json/master/countries/NER.geo.json')
            .then(res => res.json())
            .then(data => setNigerGeoJson(data));
    }, []);

    return (
        <div className="container about-list-items mb-5">
            <SectionTitle pageTitle="sig"/>
            <div
                className='d-flex justify-content-center align-items-center card mt-2'
                style={{ height: '80vh', position: 'relative', overflow: 'hidden' }}
            >
                <a
                    className='btn btn-xs btn-primary'
                    href="http://192.162.68.100/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 1000 }}
                >
                    <FontAwesomeIcon icon={faMap} /> <MultiLingualContent contentID="sig" />
                </a>

                {/*<iframe
                    src="http://192.162.68.100/"
                    title="SIG Map"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    allowFullScreen
                />*/}
                <MapContainer
                    center={[17.6078, 8.0817]} // Centre du Niger
                    zoom={6}
                    style={{ height: '100%', width: '100%', position: 'absolute', zIndex: 0 }}
                >
                    {/* Fond de carte */}
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; OpenStreetMap contributors'
                    />
                    {/* Couche Niger */}
                    {nigerGeoJson && (
                        <GeoJSON
                            data={nigerGeoJson}
                            style={{
                                color: '#e63946',
                                weight: 2,
                                fillColor: '#e63946',
                                fillOpacity: 0.2,
                            }}
                        />
                    )}
                </MapContainer>

            </div>
        </div>
    );
};

export default SigMap;